import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M14,8.75H2a.75.75,0,0,1,0-1.5H14a.75.75,0,0,1,0,1.5Zm-2.61,4.72-2.86-3a.78.78,0,0,0-1.08,0l-2.87,3a.75.75,0,0,0-.15.82.74.74,0,0,0,.69.46h5.73a.73.73,0,0,0,.69-.46A.75.75,0,0,0,11.39,13.47Zm.15-11.76a.73.73,0,0,0-.69-.46H5.12a.75.75,0,0,0-.54,1.27l2.87,3A.73.73,0,0,0,8,5.72a.76.76,0,0,0,.54-.23l2.86-3A.74.74,0,0,0,11.54,1.71Z';
const draw24px =
  'M16.11,19a.74.74,0,0,1-.53.22.71.71,0,0,1-.53-.22l-2.27-2.27V22a.75.75,0,0,1-1.5,0V16.75L9,19a.74.74,0,0,1-1.06,0,.75.75,0,0,1,0-1.06l3.55-3.55h0a.74.74,0,0,1,.38-.2,1.41,1.41,0,0,1,.29,0,.73.73,0,0,1,.39.2L16.11,18A.75.75,0,0,1,16.11,19ZM12,14.19l-.15,0a1.41,1.41,0,0,1,.29,0A.34.34,0,0,0,12,14.19ZM16.11,5a.74.74,0,0,0-1.06,0L12.78,7.28V2a.75.75,0,0,0-1.5,0V7.28L9,5A.74.74,0,0,0,7.94,5a.75.75,0,0,0,0,1.06l3.55,3.55h0a.67.67,0,0,0,.24.16.68.68,0,0,0,.29.06l.15,0a.74.74,0,0,0,.38-.2l3.55-3.55A.75.75,0,0,0,16.11,5Zm4.67,7a.76.76,0,0,0-.75-.75H4a.75.75,0,0,0,0,1.5H20A.75.75,0,0,0,20.78,12Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const ArrowAlignCenterHorizontalIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'arrowAlignCenterHorizontal')) as IconWithRender;

ArrowAlignCenterHorizontalIcon.displayName = 'ArrowAlignCenterHorizontalIcon';
ArrowAlignCenterHorizontalIcon.propTypes = Icon.propTypes;
ArrowAlignCenterHorizontalIcon.renderIcon = (props) => (
  <ArrowAlignCenterHorizontalIcon {...props} />
);
export default ArrowAlignCenterHorizontalIcon;
